import React, { useEffect, useState } from 'react';
import './UpdatePrompt.css';

function UpdatePrompt() {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    // Đăng ký lắng nghe sự kiện có service worker mới
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        registration.addEventListener('waiting', event => {
          if (event.target.state === 'waiting') {
            setWaitingWorker(event.target);
            setShowReload(true);
          }
        });
      });
    }
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage('skipWaiting');
    setShowReload(false);
    window.location.reload();
  };

  if (!showReload) return null;

  return (
    <div className="update-prompt">
      <div className="update-prompt-content">
        <p>Có phiên bản mới!</p>
        <button onClick={reloadPage}>
          Cập nhật ngay
        </button>
      </div>
    </div>
  );
}

export default UpdatePrompt; 